import { takeLatest, call, put } from 'redux-saga/effects'
import _ from 'lodash'
import dashApi from 'services/api/dashApi'
import { userTypes, userCreators } from 'containers/Base/redux'

const { forgotPasswordSuccess, forgotPasswordFailure } = userCreators

function * forgotPassword (action) {
  const { data, option } = action
  const params = _.assign(data, option)
  const forgotPasswordResponse = yield call(dashApi.forgotPassword, params)

  if (forgotPasswordResponse.ok) {
    yield put(forgotPasswordSuccess(data))
  } else {
    yield put(forgotPasswordFailure(forgotPasswordResponse.data.error))
  }
}

export default function * defaultSaga () {
  yield takeLatest(userTypes.FORGOT_PASSWORD_REQUEST, forgotPassword)
}
